import React, { Component } from 'react';
import View from '../../hoc/View';
import { withRouter, Redirect } from 'react-router-dom';
import { OUR_COFFEE_LINK } from '../../utils/constants';
import Loader from '../../components/UI/Loader';
import { string, func } from 'prop-types';

class ItemDetails extends Component {
  static propTypes = {
    getData: func,
    pageType: string,
  }

  static defaultProps = {
    getData: () => { },
    pageType: '',
  }

  state = {
    item: null,
    _isMounted: false,
  }

  componentDidMount() {
    const { getData, history } = this.props
    this._isMounted = true

    getData()
      .then(item => {
        if (this._isMounted) {
          this.setState({ item })
        }

        if (!item.length) {
          history.push(`/${OUR_COFFEE_LINK}/`)
          return <Redirect to={`/${OUR_COFFEE_LINK}/`} />
        }
      })
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  render() {
    const { item } = this.state
    const { pageType } = this.props

    if (!item) {
      return <Loader />
    }

    if (!item.length) {
      return false
    }

    return <View item={item} pageType={pageType} />
  }
}

export default withRouter(ItemDetails)